module.exports = __webpack_public_path__ + "img/flyHour.c3c6da19.png";